var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "step-wizard-container" },
    [
      _vm.stepNumber && _vm.title
        ? _c("h2", { staticClass: "step-title" }, [
            _vm._v(
              _vm._s(_vm.stepText) +
                " " +
                _vm._s(_vm.stepNumber) +
                " | " +
                _vm._s(_vm.title)
            ),
          ])
        : _vm._e(),
      _vm.explanation
        ? _c("div", { staticClass: "step-instructions" }, [
            _vm._v(_vm._s(_vm.explanation)),
          ])
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }